const API_URLS = {
  getHistory: 'https://api-mobile-ci-vfal.vodafone.com/auth/communicationAPI/v2/communication',
}


export { API_URLS }
